




























import {Component, Prop, Vue} from "vue-property-decorator";
import {RouterStore} from "@/interfaces/store-interfaces/router-store.interface";

@Component({
  components: {}
})
export default class PathBox extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;
  route = RouterStore.ROUTE_NAME;
  routePath = RouterStore.ROUTE_PATH;
  counterItemLimit = 0;

  // @todo after remove all static data set to MainPageConfig.ITheme
  @Prop() item: any;
  @Prop() isSmall: boolean;
  @Prop() isMoreView: boolean;
  @Prop() isChangeBackground: boolean;

  created() {
    this.onPathBox();
    window.addEventListener("resize", this.onPathBox);
  }

  onPathBox() {
    setTimeout( ()=> {
      this.counterItemLimit = Math.ceil((this.$refs.pathBoxCounter as HTMLElement).offsetWidth / 27)
    })
  }

  get isKiosk() {
    return this.$store.state.rhizome.kioskMode;
  }

  async openLink(routeName: RouterStore.ROUTE_NAME) {
    if (this.item.entity_id) {
      if (this.isKiosk) {
        top.postMessage({ action: 'open-themes-modal' }, window.location.origin)
        return
      }

      await this.$store.dispatch('routerStore/openThemePage', this.item.entity_id);
    }
    else {
      await this.$store.dispatch('routerStore/openPage', { routeName });
    }
  }

  destroyed() {
    window.removeEventListener("resize", this.onPathBox);
  }
}
